<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">CONTENTS</h1>
<p class="nonindent" id="cvia"><a class="hlink" href="#/OEBPS/9780061957710_epub_cvi_r1.htm">Cover</a></p>
<p class="nonindent" id="tpa"><a class="hlink" href="#/OEBPS/9780061957710_epub_tp_r1.htm">Title Page</a></p>
<p class="nonindent" id="deda"><a class="hlink" href="#/OEBPS/9780061957710_epub_ded_r1.htm">Dedication</a></p>
<p class="nonindent" id="c01a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c01_r1.htm">CHAPTER ONE</a></p>
<p class="nonindent" id="c02a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c02_r1.htm">CHAPTER TWO</a></p>
<p class="nonindent" id="c03a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c03_r1.htm">CHAPTER THREE</a></p>
<p class="nonindent" id="c04a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c04_r1.htm">CHAPTER FOUR</a></p>
<p class="nonindent" id="c05a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c05_r1.htm">CHAPTER FIVE</a></p>
<p class="nonindent" id="c06a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c06_r1.htm">CHAPTER SIX</a></p>
<p class="nonindent" id="c07a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c07_r1.htm">CHAPTER SEVEN</a></p>
<p class="nonindent" id="c08a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c08_r1.htm">CHAPTER EIGHT</a></p>
<p class="nonindent" id="c09a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c09_r1.htm">CHAPTER NINE</a></p>
<p class="nonindent" id="c10a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c10_r1.htm">CHAPTER TEN</a></p>
<p class="nonindent" id="c11a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c11_r1.htm">CHAPTER ELEVEN</a></p>
<p class="nonindent" id="c12a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c12_r1.htm">CHAPTER TWELE</a></p>
<p class="nonindent" id="c13a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c13_r1.htm">CHAPTER THIRTEEN</a></p>
<p class="nonindent" id="c14a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c14_r1.htm">CHAPTER FOURTEEN</a></p>
<p class="nonindent" id="c15a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c15_r1.htm">CHAPTER FIFTEEN</a></p>
<p class="nonindent" id="c16a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c16_r1.htm">CHAPTER SIXTEEN</a></p>
<p class="nonindent" id="c17a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c17_r1.htm">CHAPTER SEVENTEEN</a></p>
<p class="nonindent" id="c18a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c18_r1.htm">CHAPTER EIGHTEEN</a></p>
<p class="nonindent" id="c19a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c19_r1.htm">CHAPTER NINETEEN</a></p>
<p class="nonindent" id="c20a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c20_r1.htm">CHAPTER TWENTY</a></p>
<p class="nonindent" id="c21a"><a class="hlink" href="#/OEBPS/9780061957710_epub_c21_r1.htm">CHAPTER TWENTY ONE</a></p>
<p class="nonindent" id="acka"><a class="hlink" href="#/OEBPS/9780061957710_epub_ack_r1.htm">ACKNOWLEDGMENTS</a></p>
<p class="nonindent" id="ataa"><a class="hlink" href="#/OEBPS/9780061957710_epub_ata_r1.htm">About the Author</a></p>
<p class="nonindent" id="otba"><a class="hlink" href="#/OEBPS/9780061957710_epub_otb_r1.htm">Other Books by Edna Buchanan</a></p>
<p class="nonindent" id="fm1a"><a class="hlink" href="#/OEBPS/9780061957710_epub_fm1_r1.htm">Resounding praise for EDNA BUCHANAN and <em>PULSE</em></a></p>
<p class="nonindent" id="copa"><a class="hlink" href="#/OEBPS/9780061957710_epub_cop_r1.htm">Copyright</a></p>
<p class="nonindent" id="atpa"><a class="hlink" href="#/OEBPS/9780061957710_epub_atp_r1.htm">About the Publisher</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061957710_epub_toc_r1.vue?0c29b54b